var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4332 0.771377L18.6005 1.96416C19.081 2.44569 19.3266 3.07901 19.3034 3.74407C19.2851 4.47566 18.9462 5.193 18.3277 5.81228L6.92614 17.2963C6.40421 17.8178 6.09709 17.9741 4.94402 18.2425L0.442456 18.9679C0.254498 18.9672 0.129147 18.8359 0.131696 18.6505L1.23059 14.4562C1.48506 13.3927 1.71933 13.0248 2.23865 12.5142L10.3234 4.36562C10.4591 4.23527 10.652 4.21525 10.7541 4.31267L13.5031 7.06165C13.6362 7.20388 13.8477 7.28098 14.0957 7.24917C14.623 7.18567 15.0823 6.70756 15.1526 6.19533C15.1839 5.93375 15.1107 5.7154 14.9827 5.55138C14.9409 5.50761 12.2964 2.84624 12.2964 2.84624C12.1711 2.71494 12.1971 2.47515 12.3612 2.31328L13.6428 1.01928C14.825 -0.164956 16.4174 -0.2682 17.4332 0.771377Z",
    fill: "#7184AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImg);
export default __webpack_public_path__ + "static/media/edit_img.c87b2887fec1c59329cd5aec32895622.svg";
export { ForwardRef as ReactComponent };